import { IOS_PHONE, PHONE } from "constants/deviceInfo";
import { WEBAUTHN_PROMPT_PENDING } from "constants/storageKeys";
import { useDeviceInfo } from "hooks/useDeviceInfo";
import { useLocalStorage } from "hooks/useLocalStorage";
import { usePlatformTour } from "hooks/usePlatformTour";
import { browserSupportsPasskey } from "utils/browserSupportsPasskey";
import { useGetWebauthnCredentialsQuery } from "store/apis/webauthn";

import { PasskeyPromptCard } from "./PasskeyPromptCard";

export const PasskeyPromptGate = () => {
  const { localData: isPromptPending, setItem: setPromptPending } =
    useLocalStorage(WEBAUTHN_PROMPT_PENDING, false);

  const { data: credentials, isSuccess } = useGetWebauthnCredentialsQuery(
    undefined,
    { skip: !isPromptPending }
  );
  const { isProductTourActive } = usePlatformTour();
  const { device } = useDeviceInfo();
  const isMobileDevice = device === PHONE || device === IOS_PHONE;

  const dismiss = () => {
    setPromptPending(false);
  };

  if (isMobileDevice || !browserSupportsPasskey()) {
    return null;
  }

  const shouldShow =
    isPromptPending &&
    isSuccess &&
    credentials?.length === 0 &&
    !isProductTourActive;

  return <PasskeyPromptCard open={shouldShow} onDismiss={dismiss} />;
};
